module.exports = __webpack_public_path__ + "img/by.258d9b88.jpg";